module.exports = __webpack_public_path__ + "img/DK34887969.cb07e3cf.png";